<div class="therapy-prioritize-container">
  <!-- Left Side ot Therapies -->
  <section class="list-section">
    <gen-immunotherapy
      *ngIf="!!immunotherapyConfig"
      [viewMode]="true"
      [editAllowed]="false"
      [config]="immunotherapyConfig"
    ></gen-immunotherapy>
    <div class="therapy-list" *ngIf="(therapies|async)?.length>0">
    <span class="title Auto_Title_Therapy_Match">Therapy matches</span>
    <gen-therapies-list class="section-wrapper Auto_Therapy_Match_list"
                        [revisionId]="revisionId"
                        [workflowInputs]="workflowInputs$|async"
                        [therapies]="therapies|async"
                        [opinion]="opinion|async"
                        [drugsList]="selectedDrugs|async"
                        [activeJobName]="activeJobName|async"
                        [caseStatus]="isPrioritizeStep && !userPassReviewLimit && (caseStatus|async)"
                        [trials]="trials|async"></gen-therapies-list>
    </div>
    <div class="therapy-list"  *ngIf="(uncharacterizedTherapies|async)?.length>0">
    <span class="title Auto_Title_Therapy_Match">Uncharacterized</span>
    <gen-therapies-list class="section-wrapper Auto_Therapy_Match_list"
                        [revisionId]="revisionId"
                        [uncharacterizedTitle]="'Uncharacterized'"
                        [uncharacterizedIconClass]="'icon__warning_background'"
                        [workflowInputs]="workflowInputs$|async"
                        [therapies]="uncharacterizedTherapies|async"
                        [opinion]="opinion|async"
                        [activeJobName]="activeJobName|async"
                        [caseStatus]="isPrioritizeStep && !userPassReviewLimit && (caseStatus|async)"
                        [trials]="trials|async"></gen-therapies-list>
    </div>
    <div class="therapy-list"  *ngIf="(notSentForInterpretationTherapies|async)?.length>0">
    <span class="title Auto_Title_Therapy_Match">Interpretation not available</span>
    <div class="reflex-warning" *ngIf="reflexMessage != ''">
      <svg class="reflex-warning__image" viewBox="0 0 48 48">
        <path fill="#212121" fill-rule="evenodd" d="M23.037 2.14c.532-.965 1.4-.955 1.927 0l23.24 42.114c.533.964.07 1.746-1.04 1.746H.837c-1.107 0-1.568-.792-1.04-1.746l23.24-42.115zm3.88 35.795c0-1.672-1.203-2.935-2.843-2.935-1.678 0-2.99 1.263-2.99 2.935 0 1.672 1.312 2.898 2.99 2.898 1.676 0 2.843-1.264 2.843-2.898zm0-22.768h-5.834l.966 17.5h3.902l.966-17.5z"/>
      </svg>
      <span class="reflex-warning__text">{{reflexMessage}}</span>
    </div>
    <gen-therapies-list class="section-wrapper Auto_Therapy_Match_list"
                        [revisionId]="revisionId"
                        [uncharacterizedTitle]="'Not Available'"
                        [uncharacterizedIconClass]="'icon__alert'"
                        [workflowInputs]="workflowInputs$|async"
                        [therapies]="notSentForInterpretationTherapies|async"
                        [opinion]="opinion|async"
                        [activeJobName]="activeJobName|async"
                        [caseStatus]="isPrioritizeStep && !userPassReviewLimit && (caseStatus|async)"
                        [trials]="trials|async"></gen-therapies-list>
    </div>
    <label class="therapy_content_provider" *ngFor="let provider of providers$">
      {{provider}}
    </label>
  </section>


  <!-- Right Side of Therapies -->

  <section *ngIf="isUiManualAberrationCurationStep && loaded" class="curation-section section-wrapper">
    <gen-manual-curation-confirmation [isPerformer]="isPerformer==1"></gen-manual-curation-confirmation>
  </section>


  <section class="reviews-sections section-wrapper" *ngIf="!isUiManualAberrationCurationStep && loaded">
    <ng-container *ngIf="reviews && reviews.length > 0">
      <section class="reviewers-section">
        <gen-therapies-selection
          *ngFor="let review of reviews;trackBy:review?.id;let i = index"
          [collapsed]="reviews.length-1 !== i"
          [count]="i+1"
          [review]="review"
          [revisionId]="revisionId"
          [edit]="false"></gen-therapies-selection>
      </section>
    </ng-container>
    <section class="user-review" *ngIf="isPrioritizeStep && userPassReviewLimit === false">
      <span class="sub-title Auto_Title_Prioritize">Select/Drag therapy to prioritize</span>
      <gen-therapies-selection class="section-wrapper Auto_Selection_Prioritize"
                               [collapsed]="false"
                               [allowManual]="allowManual"
                               [count]="reviews.length"
                               [allowTherapyFreeText]="allowTherapyFreeText"
                               [targetMaxLength]="targetMaxLength"
                               [revisionId]="revisionId"
                               [workflowId]="workflowId"
                               [displayActionButtons]="(caseStatus|async) && isPrioritizeStep && !userPassReviewLimit"
                               [edit]="true"></gen-therapies-selection>
    </section>
  </section>
  <section *ngIf="!loaded" class="curation-section section-wrapper">
    <gen-overlay-loader class="loader" [showOverlay]="false"></gen-overlay-loader>
  </section>

  <gen-dynamic-modal-loader [observableName]="'THERAPY-MATCH'"></gen-dynamic-modal-loader>
</div>
